const LoggedInLayout = () => import("../../views/LoggedInLayout.vue");

const ViewModelData = r => require.ensure([], () => r(require('./views/ViewModelData.vue')))
const ViewModelDataProcess = r => require.ensure([], () => r(require('./views/ModelDataProcess.vue')))

const moduleRoute = {
  path: "/",
  component: LoggedInLayout,
  children: [
    
    {
      path: "/modeldata",
      component: ViewModelData
    },
    {
      path: "/modeldataprocess",
      component: ViewModelDataProcess
    }
  ]
};

export default router => {
  router.addRoutes([moduleRoute]);
};
